import { Box, Card } from "@mui/material";
import { useGetStateListQuery } from "features/dashboard/RiskManagement/RiskManagementApiSlice";
import { useGetAllAnalyticsDataMutation } from "features/masterdata/MasterApiSlice";
import { useEffect, useState } from "react";
import Select from "react-select";
import { DateRangePicker } from "rsuite";
import { useGetDistrictByStateQuery } from "services/locationApiSlice";
import TopLocationChart from "components/analytics/TopLocationChart";
import BankingSection from "components/analytics/BankingAnalytics/Components/BankingSection";
import { SectionHeader } from "components/analytics/BankingAnalytics/Components/AnalyticsCard";
import { selectCurrentRoles } from "features/auth/authSlice";
import { useSelector } from "react-redux";

import LoanAnalyticsCharts from "./LoanAnalyticsCharts";
import { useGetSaathiFLEQuery } from "features/CrmDashboardComp/CmrApiSlice";
import { useGetPospListQuery } from "./BankingApiSlice";
import * as XLSX from "xlsx";
import { Button } from "reactstrap";
import { ProductNameFilter } from "./ProductNameFilter";
import BankingTabSection from "./BankingTabSection";

const BankingMisAnalytics = () => {
  const [
    getAllAnalyticsData,
    { data: analyticsData },
  ] = useGetAllAnalyticsDataMutation();
  const RolesFromToken = useSelector(selectCurrentRoles);

  const [stateId, setStateId] = useState(null);
  const [districtId, setDistrictId] = useState(null);
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [SelectedFle, setSelectedFle] = useState("");
  const [dateRange, setDateRange] = useState(undefined);
  const [productName, setProductName] = useState("");
 const [bank_name, setBankName] = useState(RolesFromToken?.groups?.includes("Banker")?"State Bank of India" : RolesFromToken?.groups?.includes("Bank_Of_Baroda_Banker")?"Bank Of Baroda":"");
  const { data: getStates } = useGetStateListQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId, {
    skip: !stateId,
  });
  const { data: FleList } = useGetSaathiFLEQuery(
    { districtId: "", searchKey: "" },
    { refetchOnMountOrArgChange: true }
  );
  const { data: PospList } = useGetPospListQuery(
    { districtId: "", searchKey: "" },

    { refetchOnMountOrArgChange: true }
  );
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [FleData, setFleList] = useState([]);

  useEffect(() => {
    if (getStates?.data?.results) {
      setStateList(getStates.data.results);
    }
  }, [getStates]);

  useEffect(() => {
    if (dataDistrict?.data?.results) {
      setDistrictList(dataDistrict.data.results);
    }
  }, [dataDistrict]);
  useEffect(() => {
  if (FleList || PospList) {
    setFleList(
      [
        ...(FleList?.data?.results || []),
        ...(PospList?.data?.results || []),
      ].sort((a, b) =>
        (a?.full_name || "").localeCompare(b?.full_name || "")
      )
    );
  }
}, [FleList, PospList]);
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()}`;
  };

  useEffect(() => {
    const [from, to] = dateRange || [];

    const payload = {
      ...(stateName && { state_name: stateName }),
      ...(districtName && { district_name: districtName }),
      ...(from ? { from_date: formatDate(from) } : {}),
      ...(to ? { to_date: formatDate(to) } : {}),
      ...(SelectedFle && { agent_id: SelectedFle }),
      ...(bank_name && { bank_name: bank_name }),
      ...(productName && { product_name: productName }),
      top_number: 10,
    };

    getAllAnalyticsData(payload);
  }, [stateName, districtName, dateRange, SelectedFle, getAllAnalyticsData,bank_name,productName]);

  const onLocationChange = (selectedOption) => {
    if (!selectedOption) return;

    const { ConditionName, value, label } = selectedOption;

    if (ConditionName === "state") {
      setStateId(value);
      setStateName(label);
      setDistrictId(null);
      setDistrictName("");
    }

    if (ConditionName === "district") {
      setDistrictId(value);
      setDistrictName(label);
    }
  };

  const handleClear = (type) => {
    if (type === "state") {
      setStateId(null);
      setStateName("");
      setDistrictId(null);
      setDistrictName("");
    } else if (type === "district") {
      setDistrictId(null);
      setDistrictName("");
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "40px",
      height: "40px",
      fontSize: "13px",
      zIndex: 100,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 3000,
    }),
  };

  const handleStateOptions = () =>
    [...stateList]
      .sort((a, b) => a.state_name.localeCompare(b.state_name))
      .map((state) => ({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      }));

  const handleDistrictOptions = () =>
    [...districtList]
      .sort((a, b) => a.district_name.localeCompare(b.district_name))
      .map((district) => ({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      }));

  const handleDateChange = (range) => {
    if (!range || range.length === 0) {
      setDateRange([]);
    } else {
      setDateRange(range);
    }
  };

  const banking = analyticsData?.data?.banking;

  const formattedStateData =
    banking?.top_states?.map((item) => ({
      name: item.state_name,
      value: item.total_count,
    })) || [];

  const formattedDistrictData =
    banking?.top_districts?.map((item) => ({
      name: item.district_name,
      value: item.total_count,
    })) || [];

 

  const downloadDashboardExcel = (data) => {
    const workbook = XLSX.utils.book_new();
    const summaryRows = Object.entries(data.summary || {}).map(
      ([key, value]) => ({
        Metric: key.replace(/_/g, " "),
        Value: value,
      })
    );

    const summarySheet = XLSX.utils.json_to_sheet(summaryRows);
    XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");

    const dailySheet = XLSX.utils.json_to_sheet(data?.timeseries?.daily || []);
    XLSX.utils.book_append_sheet(workbook, dailySheet, "Daily");

    const monthlySheet = XLSX.utils.json_to_sheet(
      data?.timeseries?.monthly || []
    );
    XLSX.utils.book_append_sheet(workbook, monthlySheet, "Monthly");

    const yearlySheet = XLSX.utils.json_to_sheet(
      data?.timeseries?.yearly || []
    );
    XLSX.utils.book_append_sheet(workbook, yearlySheet, "Yearly");

    const productsSheet = XLSX.utils.json_to_sheet(data.top_products || []);
    XLSX.utils.book_append_sheet(workbook, productsSheet, "TopProducts");

    const statesSheet = XLSX.utils.json_to_sheet(data.top_states || []);
    XLSX.utils.book_append_sheet(workbook, statesSheet, "TopStates");

    const districtsSheet = XLSX.utils.json_to_sheet(data.top_districts || []);
    XLSX.utils.book_append_sheet(workbook, districtsSheet, "TopDistricts");

    const agentsSheet = XLSX.utils.json_to_sheet(data.top_agents || []);
    XLSX.utils.book_append_sheet(workbook, agentsSheet, "TopAgents");

    XLSX.writeFile(workbook, "Banking_Report.xlsx");
  };

  return (
    <div>
      {!(
        RolesFromToken?.groups?.includes("State Head") ||
        RolesFromToken?.groups?.includes("District Head") ||
        RolesFromToken?.groups?.includes("Cluster Head") ||
        RolesFromToken?.groups?.includes("Banking Admin")
      ) && (
        
        <BankingTabSection activeTab={
            RolesFromToken?.groups?.includes("Banker") ||
            RolesFromToken?.groups?.includes("Bank_Of_Baroda_Banker")
              ? "Dashboard"
              : "Analytics"
          }/>
      )}
      <Box
        sx={{ p: 1 }}
        className="position-relative container-fluid px-lg-2 mt-4"
      >
        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-3 gap-3 ">
          <div
            className="d-flex flex-wrap justify-content-start gap-2 col-12 col-lg-12"
            style={{ marginTop: "" }}
          >
            <div
              className="flex-grow-1 flex-lg-grow-0"
              style={{ minWidth: "220px" }}
            >
              <Select
                options={handleStateOptions()}
                placeholder="State"
                value={
                  stateId
                    ? {
                        value: stateId,
                        label: stateName,
                        ConditionName: "state",
                      }
                    : null
                }
                onChange={(option) => {
                  if (!option) handleClear("state");
                  else onLocationChange(option);
                }}
                styles={customStyles}
                isClearable
              />
            </div>

            <div
              className="flex-grow-1 flex-lg-grow-0"
              style={{ minWidth: "220px" }}
            >
              <Select
                options={handleDistrictOptions()}
                placeholder="District"
                value={
                  districtId
                    ? {
                        value: districtId,
                        label: districtName,
                        ConditionName: "district",
                      }
                    : null
                }
                onChange={(option) => {
                  if (!option) handleClear("district");
                  else onLocationChange(option);
                }}
                styles={customStyles}
                isDisabled={!stateId}
                isClearable
              />
            </div>

            <div
              className="flex-grow-1 flex-lg-grow-0 analytics-date"
              style={{ minWidth: "200px" }}
            >
              <DateRangePicker
                style={{ width: "100%" }}
                placeholder="Select Date Range"
                value={dateRange}
                onChange={handleDateChange}
                format="dd MMM yyyy"
                placement="auto"
                shouldDisableDate={(date) => date > new Date()}
              />
            </div>
                          {!( RolesFromToken?.groups?.includes("Banker") || RolesFromToken?.groups?.includes("Bank_Of_Baroda_Banker")) &&

            <div
              className="flex-grow-1 flex-lg-grow-0"
              style={{ minWidth: "200px" }}
            >
              <Select
                options={
                  FleData?.map((item) => ({
                    label: item.full_name,
                    value: item.id,
                  })) || []
                }
                placeholder="FLE & POSP"
                value={
                  SelectedFle
                    ? FleData?.map((item) => ({
                        label: item.full_name,
                        value: item.id,
                      })).find((option) => option.value === SelectedFle)
                    : null
                }
                onChange={(selectedOption) => {
                  setSelectedFle(selectedOption?.value || "");
                }}
                styles={customStyles}
                isClearable
              />
            </div>  }
           
            <ProductNameFilter bank_name={bank_name} setBankName={setBankName} setProductName={setProductName} productName={productName} customStyles={customStyles}/>   
          </div>

        
        </div>
       <div className="d-flex justify-content-between align-items-center mb-3">
        <SectionHeader title="Banking Analytics" />
          <Button
            id="AddLeads"
            className="buttonGreenDefaultColor"
            onClick={() => downloadDashboardExcel(banking)}
            size="sm"
          >
            Download &nbsp;
            <i className="mdi mdi-download"></i>
          </Button>
          </div>
        <LoanAnalyticsCharts data={analyticsData?.data?.banking?.summary} />
           
        <BankingSection
          analyticsData={analyticsData}
          getAllAnalyticsData={getAllAnalyticsData}
          mainStateName={stateName}
        />

        <div className="d-flex flex-column flex-lg-row gap-4 mb-5">
          <Card className="rounded w-100">
            <h5 className="bg-secondary2" style={{ padding: "12px 15px" }}>
              Top Permorming States - Loan
            </h5>
            <TopLocationChart
              location={formattedStateData}
              showLoading={false}
            />
          </Card>
          <Card className="rounded w-100">
            <h5 className="bg-secondary2" style={{ padding: "12px 15px" }}>
              Top Performing Districts - Loan
            </h5>
            <TopLocationChart
              location={formattedDistrictData}
              showLoading={false}
            />
          </Card>
        </div>
      </Box>
    </div>
  );
};

export default BankingMisAnalytics;
